import { initialState, LoginInfoState } from '@/config/initialState';
import { store } from '@/config/store';
import { Car, CustomerInfoApiResponse } from '@/types/api/customerApi';
import { getCustomerInfoRestrictionRequest } from '@/utils/prepaidRestrictionRequest';
import {
  findRelevantNextWarranty,
  getPreferredCurrentWarranty,
} from '@/utils/warranty';

type StoreStateUpdate<StateName extends string> = StateName extends 'loginInfo'
  ? Partial<LoginInfoState>
  : unknown;

export const storeDispatch = async <StateName extends string>(
  actions: string,
  stateName: StateName,
  newState: StoreStateUpdate<StateName>,
) => {
  await store.dispatch(actions, {
    [stateName]: newState,
  });
};

export const dispatchBasicInfo = async (
  customerInfo: CustomerInfoApiResponse['data'],
  findFnc?: (value: Car) => unknown,
) => {
  const context = getCustomerInfoRestrictionRequest(customerInfo.customer);
  if (
    (customerInfo.customer?.id &&
      customerInfo.customer.id !== store.state.authInfo.m_customer_id) ||
    (context && context.customerId !== store.state.authInfo.m_customer_id)
  )
    return;
  const {
    customer,
    cars,
    bill_infomations,
    payment_methods,
    prepaids,
    informations,
    campaigns,
  } = customerInfo;
  const promises = [
    storeDispatch('setCustomerInfo', 'customerInfo', customer),
    storeDispatch('setCarsInfo', 'carsInfo', cars),
    storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
    storeDispatch(
      'setPaymentMethodsInfo',
      'paymentMethodsInfo',
      payment_methods,
    ),
    storeDispatch('setAdvancePaymentsInfo', 'advancePaymentsInfo', prepaids),
    storeDispatch('setNotificationsInfo', 'notificationsInfo', informations),
    storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
  ];
  const car =
    (findFnc ? cars?.find(findFnc) : cars?.[0]) ||
    cars?.[0] ||
    initialState.carItemInfo;
  const warranties = car.warranties || [];
  const nextWarranties = car.next_warranty || [];
  const preferredWarranty = getPreferredCurrentWarranty(warranties);
  promises.push(
    storeDispatch('setCarItemInfo', 'carItemInfo', car),
    storeDispatch('setWarranties', 'warranties', warranties),
    storeDispatch('setNextWarranties', 'nextWarranties', nextWarranties),
    storeDispatch('setCurrentWarranty', 'currentWarranty', preferredWarranty),
    storeDispatch(
      'setNextWarranty',
      'nextWarranty',
      findRelevantNextWarranty(preferredWarranty, nextWarranties),
    ),
  );
  await Promise.all(promises);
};
